import { useContext } from 'react'

import { ParametrizationSimilarProductContext } from '@provider/Parametrization/SimilarProduct'

import type { IParametrizationSimilarProductContext } from '@base/@types/providers/Parametrization/SimilarProductProvider'

export default function useParametrizationSimilarProduct(): IParametrizationSimilarProductContext {
  const context = useContext(ParametrizationSimilarProductContext)

  return context
}
